// Austin logo wall data. First 7 entries are the legacy AUSTIN_LOGOS
// array from LogoList.jsx, unchanged. The next 6 are enterprise SVGs
// added in the redesign-2025-logo-marquee branch (historical branch name) — sourced as single-
// color dark wordmarks with a 300×120 viewBox, dropped into
// public/static/images/logos/ in PascalCase to match the existing
// Austin asset convention (Apple.svg, Dell.svg, …).
//
// No slot overrides yet — residential / breweries / community land in
// PR2 once the 18 Austin-area assets are sourced. Until PR2 ships, the
// pickSlot fallback in LogoList.jsx returns `common` for missing slots,
// which fixes the Seattle-leak bug where Austin pages rendered
// Seattle's hardcoded slot arrays.
const common = [
  { src: '/static/images/logos/Apple.svg', alt: 'Apple' },
  { src: '/static/images/logos/Dell.svg', alt: 'Dell' },
  { src: '/static/images/logos/IBM.svg', alt: 'IBM' },
  { src: '/static/images/logos/WholeFoods.svg', alt: 'Whole Foods' },
  { src: '/static/images/logos/CrowdStrike.svg', alt: 'CrowdStrike' },
  { src: '/static/images/logos/HEB.svg', alt: 'H-E-B' },
  { src: '/static/images/logos/UTAustin.svg', alt: 'University of Texas at Austin' },
  { src: '/static/images/logos/Amazon.svg', alt: 'Amazon' },
  { src: '/static/images/logos/Indeed.svg', alt: 'Indeed' },
  { src: '/static/images/logos/Meta.svg', alt: 'Meta' },
  { src: '/static/images/logos/Oracle.svg', alt: 'Oracle' },
  { src: '/static/images/logos/TMobile.svg', alt: 'T-Mobile' },
  { src: '/static/images/logos/Tesla.svg', alt: 'Tesla' },
];

export default { common };
